module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ANDY")])]), _vm._v(" stared at her reflection in the small round mirror in the aeroplane’s toilet, and it was with something of a sense of shock that she took in the image peering back at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thick, silky hair of a glowing russet-red hanging in soft waves to slender shoulders, vivid sapphire-blue eyes under finely arched brows, clear, creamy skin dotted with the merest sprinkling of freckles across a small straight nose… It looked like her, admittedly, she thought numbly, and yet how could the pain and frightening bitterness of the last months not show on the face of the girl who gazed back at her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she had always been good at hiding her real feelings. The thought brought her small chin up in unconscious defiance of the voice inside her head telling her she couldn’t do this, that she should have stayed in Canada where everything was safe and normal, that she wasn’t strong enough yet to strike out on her own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You are a survivor, Candy Grey.’ She brushed back the wispy fringe from her forehead as she spoke out loud, and on realising her hands were trembling she clenched them into fists at her side. ‘You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(".’ The azure gaze became a glare that dared her to contradict it. ‘And you are going to make it.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_vm._v("The future might not be what she had imagined for herself this time a year ago, but so what? The narrowed eyes with their abundantly thick lashes were unflinching. She could either wallow in self-pity, and eventually let it drown her, or she could make a new life for herself—a life where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" called all the shots and where she was answerable to ")]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("no one. Life on her own terms. She nodded at the declaration, her slim shoulders straightening.")])]), _c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once back in her comfortable seat in the first-class section of the plane, she ignored the none too subtle overtures from the man in the next seat, who had proved a pain for the whole of the journey from Vancouver, and endeavoured to prepare herself for the landing at Heathrow. Then, once she had battled her way through the terminal, she could pick up the car one of Xavier’s business colleagues had arranged to have waiting for her arrival and, bingo, she was on her way, she told herself firmly. And so it proved.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Within a short time of the plane landing she was ensconced in a little blue Fiesta, her luggage filling the boot and back seat and spilling over on to the passenger seat at the side of her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It took her several attempts to navigate her way out of London but she didn’t panic. After the bottomless abyss of the last months what was getting lost in the overall scheme of things? Candy asked herself caustically on eventually finding herself in the outskirts. If nothing else she had learnt what was important and what was not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Autonomy was important. Being able to choose what she wanted to do and when she wanted to do it. She flexed her long slim legs at the memory of her endless months in the wheelchair and drew in the air very slowly between her small white teeth. She might still get exhausted very quickly, and the self-physiotherapy the doctor had taught her would have to continue for some months yet, but she was mistress of her own destiny again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And it could have all been so different. The horrendous accident that had taken Harper could so easily have left her in a wheelchair for life. All things considered, she was lucky.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_vm._v("The thought mocked the devastation of what was left of ")]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("her life, but Candy reiterated it in her mind almost defiantly. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" lucky, she told herself firmly.")])]), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had fought back against the consuming thick grey blanket of depression which had weighed her down in the early days, throwing it off with Herculean resolve. She had climbed out of the dark, mindless pit of that time and she was blowed if she would allow herself to be sucked into it again by self-pity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And everyone had been so good to her, and still continued to be. Of course they all felt sorry for her, she acknowledged a trifle bitterly. She knew exactly what they’d been saying. The car accident, her fiancé being killed, Candy’s struggle to emerge from the coma she had been in for days after the collision only to surface to the realisation that she might never walk again—it was all "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("terrible")]), _vm._v(", they’d said soberly. No wonder dear Candy was depressed and apathetic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she had let them believe what was convenient. She hadn’t told a living soul the real reason for the suicidal emptiness of those early days and she never would.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The strident honking of an oncoming car brought Candy sharply out of the morass of black memories, and, although the other driver’s anger was directed at a smart red sports car which had deliberately cut across its path, the incident was enough to nudge her mind fully back to her driving.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The November day was bright but bitterly cold, bare branches of trees reaching out into a silver-blue sky as the car ate up the miles along the pleasant countrified route Candy was following.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("It was just after three when she reached the small Sussex town she had been making for, and she was exhausted. She glanced at the carefully written instructions she’d fixed to the dashboard and followed them to the letter. Within ten minutes the car had turned off the tree-lined road of pros")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("perous-looking homes and on to a wide pebbled drive in front of a large, sprawling detached house.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Veterinary Surgery.’ Never had two words looked sweeter. Candy cut the engine, leant back in the seat and stretched her neck, running her hands through her hair before massaging her scalp lightly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The drive had been a short one compared to the long hauls she was used to making as part of everyday life in Canada, but it was at times like this that her body reminded her—all too stringently—that she wasn’t quite so well as she would like to believe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, all she had to do now was collect the key of Essie’s cottage from Quinn Ellington, who now owned the practice, and follow his instructions for the last mile or two. Easy. She rotated her head once more and climbed out of the car, walking across the drive to the big old-fashioned oak door and ringing the bell before stepping back a pace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The seconds ticked by, and after a full minute Candy tried the bell again. And again. When that didn’t bring a result she turned the big brass doorknob and stepped gingerly into a large square hall, the white and black tiles on the floor spangled by the autumn sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hall was empty, and so was the reception area beyond it, but just as she seated herself somewhat uncertainly in one of the straight-backed upholstered chairs dotted about the bright and cheerful waiting area, a large middle-aged woman popped her head round the door leading from the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you Candy? Xavier’s niece?’ It was rushed and harassed, and Candy only managed a quick nod—opening her mouth to speak before the woman cut in again with, ‘We’ve got an emergency. I must get back. Wait there and Quinn will be with you as soon as he can.’ Then the door closed again and all was quiet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("Great. Candy stared blankly across the space. She hadn’t ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("expected the red carpet treatment or anything like that, but a, Hi, how are you? or a, Nice to meet you, wouldn’t have come amiss.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She eased her flat leather shoes off her feet and dug the fingers of both hands into the small of her back, working tense, bunched muscles for some moments before settling back with a tired sigh and shutting her eyes. She might as well relax while she waited, she decided drowsily. No point in getting ruffled. She let her head fall back against the whitewashed wall behind her and was asleep in the next moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Quinn walked into the reception area five minutes later he had the apology hovering on his lips, but instead of a possibly irate or testy young woman confronting him he saw Candy. Fast asleep, her coppery hair in silky disarray, thick eyelashes lying like smudges on the pale cream of a skin that looked to be translucent. Impossibly lovely and quite alarmingly fragile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped abruptly, ebony eyes narrowing into slits of black light, and he remained like that for a good few seconds before glancing at his watch. Five minutes and she was sleeping the sleep of the dead; she must have been out on her feet. Still, that wasn’t surprising. He knew Xavier and Essie had been hotly against this young woman making the journey from Canada alone, but Essie had informed him—ruefully—that Xavier’s niece had a lot of her uncle’s stubbornness. It was in the genes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("He hadn’t expected her to be quite so beautiful; her photo hadn’t done her justice. The thought came from nowhere and Quinn brushed it aside irritably, his strong, chiselled face hardening. This was Xavier’s niece and she had been through hell; whether she was beautiful or not was irrelevant. She needed peace and quiet and looking after, although the last was to be done without her knowledge. But ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("he’d promised Xavier and Essie he would keep an eye on this young woman and he would. In a fatherly fashion.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced again at the lovely face, the dusky red lips lying slightly open in a small pout, and felt his senses stir before he turned sharply, making his way through the heavy fire door into the rear of the building and walking to the end of a long corridor, into the surgery’s neat, shining kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marion was in there, her plump, good-natured face flushed and perspiring. ‘The coffee’s nearly ready.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She’s asleep.’ He inclined his head towards the door. ‘But thanks anyway. I’ll take the tray through in a minute and wake her up. And thanks for helping out too; it would happen today of all days.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They had just dealt with the canine victim of a road accident, and due to the fact Quinn had sent his two assistant vets out on calls, and the practice nurse was off ill with flu, there had only been Marion—his very able but slightly squeamish receptionist—to assist whilst he conducted the emergency operation the dog’s injuries had necessitated. But all had gone well and that was the main thing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marion smiled at him now, nodding at his face as she said, a touch of laughter in her voice, ‘Wipe the blood off first, eh? You’re liable to frighten the poor girl to death like that.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn flicked a glance at himself in the square triangle of mirror above the sink as he muttered, ‘Damn it.’ He wiped the blood off his cleft chin and one hard, angular cheekbone before raking back a lock of jet-black hair off his forehead with his damp hands and making an effort to smooth down the rest of his unruly locks. ‘I need a haircut.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("‘I’ve been telling you that for weeks,’ said Marion with a motherly sigh. The trouble was, Quinn couldn’t care less about his appearance, she thought fondly. Considering the quite shattering ruthless attractiveness of the man that ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("seemed to make him irresistible to every female he came into contact with, he was the most modest individual she had ever met. And that in itself proved to be an added fascination. The magnetism he exuded was lethal, but because he neither understood or wanted it he simply didn’t acknowledge it existed. Which was typical Quinn, really. As her eighteen-year-old daughter had said when she had first set eyes on him, ‘Mum, he’s walking dynamite!’")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Put a few of your shortbread biscuits on, Marion,’ said Quinn now, indicating the tray with a wave of his hand. ‘She looks like she needs feeding up a bit.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘For goodness’ sake don’t tell her that,’ Marion said quickly, her face horrified. Another of Quinn’s attributes—she wasn’t sure if it was a virtue or not—was an alarming tendency towards directness which cut through all equivocation and flannel and went straight to the heart of any matter. It was refreshing in a world where most people were falling over backwards to present themselves in the best light possible, but it did cause problems. And yet he was the most compassionate soul she had ever met. An enigma. Marion nodded at the thought. That was Quinn all right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy was still fast asleep when Quinn walked through with the tray of coffee and shortbread a few minutes later, but this time he didn’t allow himself to meditate on the delicate beauty and far too slender form slumped in the chair before he gently shook her awake.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("However, in the few moments before she opened her eyes he found himself reflecting that this paternal role he had told himself he would adopt might be a little…inappropriate. The photograph he had received of Essie’s wedding, which had taken place under blue Caribbean skies in March, had seemed to suggest that Candy, who had been Essie’s bridesmaid, was a tiny, thin little waif of a thing. Mind, she had been in the early days of recovery from the accident and still in a wheelchair, he ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("reminded himself ruefully. He should have taken that into consideration.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy came out of the layers of sleep slowly, like a drowsy child, her small pink tongue moistening her lips, and again something stirred in Quinn which he found he didn’t want to examine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Coffee?’ As Candy opened eyes of dazzling blueness Quinn kept his voice low and calm, his tone reflecting the soothing quality he used with more nervy patients when he needed to reassure them all was well. ‘You fell asleep waiting for me,’ he said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, did I?’ For a moment Candy couldn’t focus, and then, as a pair of ebony eyes set in a truly gorgeous dark, handsome face came into view in front of her, she shot up straight, her face flooding with colour. The movement was too violent for the recently healed vertebrae which had suffered the main extensive bruising and swelling, and she winced, a soft, ‘Oh’ escaping her lips before she could restrain it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you all right?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn was all concern, but Candy had had enough fussing over the previous twelve months to last a lifetime, and her tone reflected this when she said, ‘Perfectly, thank you. I was just a little startled, that’s all.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Okay, so she didn’t want him asking after her health. Quinn smiled widely, not at all taken aback by her coolness. Coolness he could take; in fact coolness was a refreshing change after some of the gushing and simpering from the females round these parts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Black or white?’ he asked blandly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The coffee.’ His tone was patient now, pointedly so.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("‘Oh.’ Candy’s flush deepened. She was behaving badly and she didn’t know why, except that this man was… Well, he wasn’t what she’d expected. When Essie had spoken of ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("her old work colleague she had never indicated he was a Pierce Brosnan lookalike…")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well?’ The glittering gaze pinned hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘White, please. Two sugars.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She watched him while he poured the coffee and she had to admit he was something else. Big, lean, sexy—how could Essie not have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("told")]), _vm._v(" her? But then her uncle’s wife had eyes for no one but her husband, and he for her; ‘wrapped up in each other’ didn’t even begin to describe it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As though he had read her thoughts, Quinn said, ‘How’s Essie? I hear there’s a little Grey on the way?’ as he raised his head and handed her the coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy nodded stiffly. ‘Just about. The baby’s due in June.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hell, but this one was prickly. Had she always been like this or had the accident made her this way? Whatever, he was going to have his work cut out to communicate at all, let alone act as the buddy Essie had asked him to be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then, in confirmation of the thought, Candy said formally, ‘I understand you have the key to Essie’s cottage, Mr Ellington?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What was with this Mr Ellington? ‘Quinn. The name’s Quinn.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyelashes flickered. ‘The thing is, it’s been a long journey and I would like to get settled in, so if you could give me the instructions on how to find Essie’s cottage I’ll get out of your hair.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He liked her Canadian drawl. Even when she was trying to be aloof and distant, like now, the accent was warm and lazy. ‘I’ll do better than that,’ Quinn offered easily. ‘I’m finished here now until evening surgery, and Jamie—you met him at the wedding?—and my other assistant will be back soon. I’ll lead the way, if you like, and show you how the stove and everything works.’")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I wouldn’t dream of imposing on your time in such a way,’ Candy said hastily. ‘And Essie has described everything very thoroughly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She’s a very thorough girl.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was pleasant and even, but something in Quinn’s voice told Candy he wasn’t going to be put off accompanying her. She stared into the midnight-dark eyes and then took several sips of coffee as her mind raced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her uncle Xavier—who had been mother, father, sister and brother to her for as long as she could remember, there being no other immediate family apart from her grandmother, who had died when Candy was eight years of age—had met, fallen in love with and married this man’s colleague, a fellow vet, the year before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In his pursuit of Essie, Xavier had bought this veterinary practice when the owner had put it on the market, but on their marriage they had sold the surgery to Quinn. Did Quinn now feel under some obligation—either through his purchase of the business or his previous friendship with Essie—to take her under his wing? Candy asked herself silently. Because if so it was the last thing she wanted, and she had better make that perfectly clear from day one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mr Ell—, Quinn,’ she hastily amended as she caught his eye, ‘I don’t know what Essie has told you, but I am perfectly able to look after myself.’ And then she saw it, the merest flicker of his eyes, and she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knew")]), _vm._v(". Essie had asked Quinn to nursemaid her. Prompted, no doubt, by Xavier! Oh, how could they? She knew they meant well, but the last thing in all the world she wanted was this. ‘I mean it,’ she added, her voice cold now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Shortbread?’ Quinn had watched her gather her thoughts and he knew she’d caught on; her face was very expressive as well as beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, thank you.’ It was something of a snap and he groaned inwardly. He’d blown it.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Homemade,’ he countered breezily. ‘Marion looks on herself as a surrogate mother as well as my receptionist, and she’s made it her life’s mission to feed me up.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy bit her lip and looked straight at him, her vivid blue eyes narrowing. ‘Essie has asked you to look out for me, hasn’t she?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was nothing if not straightforward, thought Quinn appreciatively. He liked that in a person; it was a rare quality these days. Of course he could dodge the question he knew she was asking, but her directness deserved better than that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes.’ It was equally forthright, and as he settled back in his chair, his ebony eyes holding her gaze and his long legs stretched out before him, Candy felt something tighten in her stomach. An awareness, a pulse, a throb of something she hadn’t felt in a long, long time, and it scared her to death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, you needn’t bother,’ she said flatly. ‘I’m not a child and I don’t appreciate being treated like one.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, whatever else, she certainly wasn’t a child, Quinn thought, as her scent—something delicate and elusive—drifted towards him as she rose abruptly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There’s something wrong with people looking out for each other?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hadn’t moved, and his voice was still relaxed and cool, but suddenly there was an element to his maleness that she hadn’t been aware of before. An authority, something imperious and cold that told her she was being stupid. And it hit her on a raw place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, of course not,’ she shot back sharply, ‘if that’s what they want. But I don’t want it; that’s the point.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And you don’t think it’s perfectly understandable that Xavier doesn’t want Essie worrying about you at such a vulnerable time in her pregnancy?’ Quinn asked silkily.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Oh, nice one. She stared at him, her eyes widening with ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("shock at being put in her place so adroitly. In one fell swoop he had accused her of being childish and selfish and ungrateful without voicing any of those things. There was a lot more to this man than met the eye, but then she had suspected that the minute she had set eyes on him. What you saw was not what you got with Mr Quinn Ellington, she told herself caustically. Mr Nice Guy when it suited him, but that was all.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I shall stay in touch with them,’ she said defiantly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s very good of you.’ It was deeply sarcastic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her nostrils flared and she would have loved to have made a grand exit, but she didn’t have the key or the instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sit down, Candy, and finish your coffee.’ It was an order, not an invitation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I would prefer to leave now, if I can have the key?’ Why was she behaving like this? Candy asked herself in disbelief. Even the note in her voice wasn’t really her. She was never petulant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sit down.’ It was a bark this time, and she sat, acknowledging, with a touch of dark humour, that he was certainly in the right profession. There wasn’t an animal alive that would step out of line if he spoke to it like that. Well, she needed the key and so she would play along, but once she had it she would make sure she never set eyes on Mr Quinn Ellington again. Essie or no Essie!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("‘Thank you.’ Quinn wasn’t sure if he was angrier with himself or this Titian-haired virago who looked like an angel but had the temper of something from the other place. But she was Essie’s fledgling, she was still recovering from the sort of accident that no one got out of alive, she was all alone in an alien country and he had promised to look out for her, damn it. He had promised. And he hadn’t lost his temper for years; why had he to start with her, now? He took a deep breath and forced his mouth out of the grim ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("line it had set in. ‘Now, please drink your coffee; you look ready to drop and it will help you concentrate on the drive to the cottage.’")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, so she was an inept driver now as well? Candy scowled at him, her eyes shooting blue sparks that negated any idea she was sleepy. But she finished the coffee and ate the finger of shortbread Quinn had wedged on the saucer. It was delicious, and she would have loved another slice, but she would rather have been hung, drawn and quartered than say so.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ready?’ Quinn rose as he spoke, and it dawned on her he was tall, very tall. He towered over her five feet eight by at least six inches, and he needed a haircut. Her eyes widened slightly as the thought hit and she pushed it aside firmly. She didn’t care if his hair grew down to his feet; it was no concern of hers if that quiff kept falling in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll meet you round the front.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had been hesitating on how to finish the meeting. It seemed a bit fatuous to thank him for the coffee, but she couldn’t very well just ask for the key again. Now, as Quinn spoke, she found herself gaping at him before she shut her mouth with a little snap. So he was still determined to escort her to the cottage? She swallowed back the hot retort that had jumped to her lips and almost choked with the effort, before sweeping past him and wrenching open the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Calm down, Candy; don’t let him get to you.")]), _vm._v(" She stood for a moment on the doorstep and breathed deeply of the crisp, cold English air before striding over to the Fiesta and unlocking the door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Once inside the car she started the engine and then waited. Within moments a sleek, beautiful champagne-coloured Aston Martin nosed on to the front drive from the back of the house. It figured. She allowed a small cynical smile to play round her angry mouth. This was a car women ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("would take a second and a third glance at, and she didn’t doubt that was why Quinn had bought it.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, why was she being so bitchy? she asked herself in the next moment, as Quinn raised a hand in acknowledgment before easing the car past the docile little Fiesta. He was entitled to drive any car he liked!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Harper had liked powerful cars. The statement was in answer to her previous thoughts, and she recognised it as such as she followed Quinn out on to the main road. The realisation made her nip at her lower lip. No, she wasn’t going to do this. She wasn’t going to get all bitter and twisted and tar all men with the same brush. No doubt there were still a few men out there, nice, ordinary men, who were capable of being faithful all their lives. The thought was without conviction, and she frowned at herself before shrugging irritably.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It didn’t matter one way or the other anyway. She didn’t intend to fall into the trap of commitment and all that hogwash ever again, so it was pointless to think along these lines. She clamped her lips together, straightened her back and followed Quinn into the sort of narrow country lane that was pure picture book England.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They passed several huge thatched cottages with magnificently laid out gardens, and within a moment or two the lane had narrowed still more to show green fields either side of the drystone walls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy was just thinking she hoped they didn’t meet any traffic from the opposite direction when Quinn’s indicator began to flash and his snail’s pace slowed still more, before he eased the Aston Martin into a pull-in just big enough to take two cars.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, Essie…’ Candy spoke out loud, as though Xavier’s wife was in the car with her, but her first sight of the cottage Essie still couldn’t bear to sell was enchanting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("It was tiny, minute, but the narrow winding path that led ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("to the gnarled front door, the pretty front garden, the white-painted exterior and quaint leaded windows under their bonnet of thatch were chocolate-box material.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The cottage looked to have masses of ground at the back, and she could imagine the gardens would be a blaze of colour come the spring, but even now, with the bare branches of the trees silhouetted against the dying gold sky, the vista was breathtaking. She could understand now why Essie had hung on to her little corner of English heaven, even though Xavier had a penthouse in London for when he was over on business. If this was hers she wouldn’t sell it. No way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she was allowed to stay here as long as she liked— Essie had been adamant about that. ‘Months, a year, two years, for ever,’ Xavier’s wife had said airily when she had first offered Candy the sanctuary. ‘Make it yours, Candy. It’s the perfect spot to resume your painting and it’s great to think of the place being used again. Xavier arranged for a lady to dust and air the place every so often, and there’s a gardener who keeps the outside under control, but other than them you won’t see a living soul unless you want to.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The last words stayed with her now, as she opened the car door and looked over to where Quinn was holding the rickety garden gate open for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Come in and have a nose round first and then I’ll get your cases,’ he said evenly, but without a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There’s really no need. I can manage perfectly well—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And then I’ll get out of your hair,’ he cut in with cool aplomb. ‘Okay?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("She ought to say she hadn’t meant she was waiting for him to leave. It was the polite thing, the courteous thing to do. But she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" meant just that and she wasn’t going to lie. Candy raised her chin a notch or two, nodded brightly, and walked over to the gate. She had to brush past him to get through, and as she did so the smell of him, a mixture ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("of delicious aftershave and something lemon, teased her nostrils, making her senses jump.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It didn’t help either that he seemed even bigger and darker than before, in the heavy black leather jacket he had pulled on over his working denims, or that the muscled strength that padded his shoulders and chest was intimidatingly close.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She concentrated on walking to the front door with every ounce of her will, and by the time she reached it she was able to stand aside and let Quinn open the door for her with the magic key without a tremor. A few more minutes and then she would be alone. She could kick her shoes off her aching feet, have a long soak in a hot tub and fall into bed. That was all she wanted. Exploring, shopping for groceries, everything else could wait until tomorrow. She had never felt so exhausted in all her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The interior of the cottage was everything the outside promised and more. Polished wood floors, beamed ceilings, whitewashed walls with one or two good paintings—it was perfect, Candy decided happily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The open-plan sitting room and tiny kitchen had stairs leading upstairs to the cottage’s bedroom and diminutive bathroom and furniture was at a minimum—just a rich deep red sofa and two easy chairs, a nest of small occasional tables, a tiny bookcase tucked under the window and two bar stools standing under the little breakfast bar which separated the kitchen from the sitting room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no TV, no microwave—although a hardy stove dominated the kitchen space—no fridge and no washing machine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("‘I’ve had the telephone reconnected.’ Quinn indicated the phone resting on the top of the nest of tables. ‘And the fire’s ready to light. There are more logs and coal stored in the old potting shed at the back of the cottage and a list ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("of everyone—doctor, dentist, coalman et cetera—pinned to the inside of the top cupboard.’")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, right, thank you.’ Candy was beginning to feel like a worm. There were fresh flowers in a vase on the bookcase, and when she opened a couple of the kitchen cupboards they were full of food. The bread bin held a crusty loaf, there was a box containing fruit and vegetables on the breakfast bar, at the side of which stood a pack of thick steaks, bacon, eggs and other produce, including a couple of bottles of very good wine. She took a deep breath and asked, ‘Did…did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" get everything in?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn shrugged. ‘No problem. I didn’t think you’d want to shop your first afternoon.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How much do I owe you?’ she asked jerkily, her cheeks fiery red.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Don’t be ridiculous,’ he said shortly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, but I must pay you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I said don’t be ridiculous.’ This time it was accompanied by a scowl that brooked no argument, before he swung round and walked over to the tiny stone fireplace, reaching up for the box of matches on the wooden mantelpiece above and flicking a match to the coals and wood in the grate. ‘It’s a bit chilly now, but it will soon warm up,’ he said quietly. ‘There’s no central heating, so it’s advisable to make sure you don’t run out of fuel.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a small, fraught silence while Candy wondered whether to press the matter of payment for the supplies, but she found she didn’t dare. ‘Thank you,’ she said again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There’s a TV point if you want to get one. Essie never liked the idea herself.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Neither do I,’ Candy said quickly. ‘I shall be painting most of the time anyway, and I love to read, especially in front of a real fire.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("‘A homebody?’ Jet-black eyes wandered over the slim, ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("expensively dressed and beautifully coiffured figure in front of him and a thick black eyebrow rose derisively. It made Candy want to hit him.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Actually, I am,’ she affirmed tightly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy reminded herself about the food and the flowers and the fire now burning brightly in the grate and swallowed hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll get your cases in.’ There was something in the silky voice that told her he was well aware of the restraint she had just employed and had relished it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She went exploring upstairs while Quinn brought her things in, and found the bedroom, with its pretty drapes and matching bedspread and leaded window under the eaves, delightful. There was no wardrobe or dressing table—Essie had warned her about the makeshift bar she had nailed to the wall which she had intended to replace with a wardrobe one day—but Candy didn’t mind that. She could perhaps buy a small pine wardrobe to match the bed, she thought to herself, and a few other things for Essie before she left. She’d see how the painting went. She had a list of contacts from her agent in Canada and several had appeared hopeful.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you want these cases upstairs?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Upstairs? The thought of Quinn in the bedroom was enough to send her scurrying down the bare wood stairs with more speed than was advisable, considering their steepness. ‘No, it’s all right,’ she said breathlessly as she almost collided into him at the bottom of the stairs. ‘I’ll sort things out later.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Leave it to tomorrow, if you can; it must have been a long day.’ She had looked like a young kid for a moment as she’d galloped down those stairs, but a kid with deep bruised shadows under her eyes and a soft mouth that was drooping with tiredness. He’d noticed she limped slightly too; it was barely discernible, but it was there.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn’s thoughts made his smile warm and open as he held out his hand. ‘Goodbye, Candy,’ he said softly. ‘If there’s anything you need don’t hesitate to call.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy hesitated for a moment, and then she carefully placed her small paw in his big fingers as she said, ‘Thank you. I mean that. I didn’t mean to be rude earlier, but it’s just that I want to be left alone.’ And then, realising that was insulting in itself, she groaned inwardly, adding quickly, ‘What I mean is—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You mean you want the space to breathe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was still holding her hand, his dark head slightly bent towards hers, but it was the note of something undefinable rather than the actual words that brought her startled blue eyes into line with his ebony gaze. She didn’t like the feel of what his hard, warm flesh was doing to her, or the fact that she knew she ought to pull away and couldn’t. But the knowledge that he knew how she was feeling, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" knew, had shocked her into immobility.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She ran the tip of her tongue over her lips and saw him follow the motion with his eyes, and the warmth it engendered was enough warning for her to be able to say, ‘Yes, that is what I mean,’ her voice guarded now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Just don’t cut yourself off so completely it becomes impossible to take up the reins again.’ His voice carried a roughness now, a huskiness that increased the warmth tenfold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did he know how sexy he was? she asked herself before she was aware what she was thinking. She didn’t think she had ever met anyone with such naked magnetism in all her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ve no intention of doing that,’ she said shakily. ‘I’m going to work here, at my painting. I’ve already got the possibility of an exhibition in London if my agent can fix it up, and—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("‘I wasn’t talking about work.’ Suddenly her hand was ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("free, and ridiculously she felt bereft. ‘I’m talking about here, inside.’ He touched the black leather over his heart. ‘There comes a point where feeling dies—take it from one who knows—and once it’s gone it can’t be resurrected.’")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was talking about himself. Candy stared at him. She wasn’t at all sure how they had reached this point, but suddenly she knew he was talking about himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You tell yourself that one day you’ll perhaps take a chance again, open up, get back into the game, and then after a time you wake up one morning and realise you’re self-sufficient. You don’t need anyone.’ His eyes were granite hard now, and inward-looking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Surely that’s good?’ she asked faintly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her voice seemed to bring him back to the present and he blinked once, a mask covering his face as he said, his voice remote, ‘Maybe, maybe not. Who knows?’ The brief moment of intimacy was over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Candy remained where she was as Quinn walked to the front door, but once he had opened it and stepped out into the bitingly cold air, in which the odd desultory snowflake was beginning to whirl and dance, she followed him to the doorway and watched him walk down the narrow garden path in the grey twilight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Goodbye, Candy.’ He turned at the gate, raking back his hair as he said, ‘I might make the odd phone call to check you’re still in the land of the living, but I promise no house calls. Okay?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Okay.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was what she had wanted, and she couldn’t have made it any plainer, so why did she feel so wretched now? Candy asked herself as she watched him back the Aston Martin out into the lane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was tired; that was what it was. And the day had been full of different impressions and images—she wasn’t thinking straight.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She raised her hand once as he left, but he didn’t glance her way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fine. She bit down hard on her lip and then closed the front door and turned to survey her new home. The breakfast bar was still piled high with food, and then she saw the little note he must have scribbled while she had been upstairs. It was propped next to an opened bottle of red wine and it read, ‘Have a couple of glasses while you cook the steak. The salad’s all ready. Q.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She drank the first glass sitting in front of the crackling fire, and she was fighting back the tears without having any idea why she wanted to cry. After putting the steak on a low grill she took the second glass up to the bathroom with her and sipped it while she soaked the aches and pains of the long journey away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was dark when she tottered downstairs again, and it was really snowing outside, thick, heavy fat flakes blotting out the view beyond the window. She drew the thick red curtains, dished up the steak and salad and poured herself another glass of wine in a spirit of recklessness before throwing another couple of logs on the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She loathed men! She bit into the steak and felt the juice dribble down her chin. She did, she loathed them all. And she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" going to do exactly what she had made up her mind to do weeks ago in Canada. Concentrate on her painting, forge a career for herself, both here and across the Atlantic, and make her work her life. She knew where she was with paint and paper. They didn’t lie, they didn’t run away and leave her, she could trust them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She finished the steak and salad, drained the glass, took a long, hard deep breath and headed for the stairs. The dishes, along with the unpacking could wait for tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And nothing—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nothing")]), _vm._v("—had changed.")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feb200ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459206724_ch01.vue
// module id = 69
// module chunks = 0